module.exports = __webpack_public_path__ + "img/news18_6.8790f4b7.jpg";